import { installNavigation } from './kanso-navigation.js';

import { createMeasurement } from './kanso-measurement.js';

installNavigation(document, window.matchMedia('(min-width: 990px)'));

const measurement = createMeasurement({
  enabled: document.documentElement.dataset.kansoAnalytics === 'true',
  get Shopify() { return window.Shopify; },
  get sessionStorage() { return window.sessionStorage; },
  location: window.location,
});
const viewed = new WeakSet();
const engaged = new WeakSet();
const invalid = new WeakSet();
let pageTracked = false;

function inspectResults() {
  for (const form of document.querySelectorAll('form[data-kanso-form]')) {
    const result = form.querySelector('[data-kanso-result]');
    if (result) measurement.finishForm(form.id, form.dataset.kansoForm, result.dataset.kansoResult);
  }
}

function ready() {
  if (!measurement.allowed()) return;
  if (!pageTracked) {
    pageTracked = measurement.publish('page_view');
    if (document.querySelector('[data-template^="article"]')) measurement.publish('article_view');
  }
  inspectResults();
  document.querySelectorAll('form[data-kanso-form]').forEach((form) => observer?.observe(form));
}

const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
  for (const { target, isIntersecting } of entries) {
    if (isIntersecting && !viewed.has(target) && measurement.publish(`${target.dataset.kansoForm}_view`, { form_location: target.id })) {
      viewed.add(target);
      observer.unobserve(target);
    }
  }
}, { threshold: 0.25 }) : null;

document.addEventListener('focusin', (event) => {
  const form = event.target.closest('form[data-kanso-form]');
  if (form && !engaged.has(form) && measurement.publish(`${form.dataset.kansoForm}_engage`, { form_location: form.id })) engaged.add(form);
});
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (form.matches('form[data-kanso-form]')) measurement.beginForm(form.id, form.dataset.kansoForm);
});
document.addEventListener('invalid', (event) => {
  const form = event.target.closest('form[data-kanso-form]');
  if (form && !invalid.has(form) && measurement.publish(`${form.dataset.kansoForm}_failure`, { form_location: form.id, reason: 'validation' })) invalid.add(form);
}, true);
document.addEventListener('input', (event) => {
  const form = event.target.closest('form[data-kanso-form]');
  if (form) invalid.delete(form);
});
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  const url = new URL(link.href, location.href);
  const section = link.closest('[id^="shopify-section-"]')?.id || 'page';
  if (['www.instagram.com', 'www.tiktok.com'].includes(url.hostname)) {
    measurement.publish('social_click', { platform: url.hostname.includes('instagram') ? 'instagram' : 'tiktok', location: section });
  } else if (url.origin === location.origin) {
    const data = { destination: url.pathname + url.hash, location: section };
    if (link.closest('nav, footer, #header-group')) measurement.publish('navigation_click', data);
    if (link.matches('.button, .button-secondary, .button-custom, .button-unstyled')) {
      measurement.publish('cta_click', { ...data, priority: url.hash === '#early-access' ? 'primary' : 'secondary' });
    }
  }
});
document.addEventListener('visitorConsentCollected', () => {
  if (!measurement.allowed()) measurement.clear();
  else ready();
});
document.addEventListener('shopify:section:load', () => {
  // Editor-only reloads never generate analytics.
  if (!window.Shopify?.designMode) ready();
});

// Focus only the response for the submitted form; several signup forms can coexist.
try {
  const returnedForm = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null;
  returnedForm?.querySelector('[data-kanso-result]')?.focus();
} catch { /* Malformed URL fragments must not interrupt navigation or analytics. */ }
if (document.documentElement.dataset.kansoAnalytics === 'true' && !window.Shopify?.designMode) {
  if (window.Shopify?.customerPrivacy) ready();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) ready(); });
}
